// import React, { useState, useEffect } from "react";
// import { Form } from "antd";
// import { ShowToast, Severty } from "../../helper/toast";
// import useRequest from "../../hooks/useRequest";
// import apiPath from "../../constants/apiPath";
// import ChatWindow from "../../components/ChatWindow";
// import ChatList from "../../components/ChatList";

// const WhatsappConfiIndex = () => {
//   const { request } = useRequest();
//   const [form] = Form.useForm();
//   const [qr, setQr] = useState(null);
//   const [authenticated, setAuthenticated] = useState(false);
//   const [chats, setChats] = useState([]);
//   const [selectedChat, setSelectedChat] = useState(null);
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);
//   const [loadingChats, setLoadingChats] = useState(false);

//   useEffect(() => {
//     const fetchQr = () => {
//       request({
//         url: "https://backend.wehadbot.com/api/business/whatsup/get-qr",
//         method: "GET",
//         onSuccess: (data) => {
//           if (data.qr) {
//             setQr(data.qr);
//           } else {
//             setAuthenticated(true);
//             setQr(null);
//             setTimeout(() => {
//               loadChats(1);
//             }, 3000);
//           }
//         },
//         onError: (error) => {
//           ShowToast(error?.response?.data?.message || "QR fetch failed", Severty.ERROR);
//         },
//       });
//     };

//     fetchQr();
//     const interval = setInterval(fetchQr, 5000);
//     return () => clearInterval(interval);
//   }, []);

//   const loadChats = (pageNumber = 1) => {
//     if (loadingChats || !hasMore) return;

//     setLoadingChats(true);

//     request({
//       url: `https://backend.wehadbot.com/api/business/whatsup/chats?page=${pageNumber}&limit=20`,
//       method: "GET",
//       onSuccess: (data) => {
//         if (data?.data?.length > 0) {
//           setChats((prev) => [...prev, ...data.data]);
//           setPage(pageNumber);
//           setHasMore(pageNumber < data.totalPages);
//         } else {
//           setHasMore(false);
//         }
//         setLoadingChats(false);
//       },
//       onError: (error) => {
//         console.error("Failed to load chats", error);
//         setLoadingChats(false);
//         ShowToast(error?.response?.data?.message || "Failed to load chats", Severty.ERROR);
//       },
//     });
//   };

//   const handleScrollEnd = () => {
//     if (hasMore) {
//       loadChats(page + 1);
//     }
//   };

//   if (!authenticated) {
//     return (
//       <div className="App" style={{ textAlign: 'center', marginTop: '50px' }}>
//         <h1>WhatsApp Web QR Login</h1>
//         {qr ? (
//           <img src={qr} alt="WhatsApp QR Code" style={{ width: 300, height: 300 }} />
//         ) : (
//           <p>Waiting for QR code or already logged in...</p>
//         )}
//       </div>
//     );
//   }

//   return (
//     <div className="app-container">
//       <ChatList chats={chats} onSelectChat={setSelectedChat} onScrollEnd={handleScrollEnd} />
//       <ChatWindow chat={selectedChat} />
//     </div>
//   );
// };

// export default WhatsappConfiIndex;

// import React, { useState, useEffect } from "react";
// import { Form } from "antd";
// import { ShowToast, Severty } from "../../helper/toast";
// import useRequest from "../../hooks/useRequest";
// import apiPath from "../../constants/apiPath";
// import ChatWindow from "../../components/ChatWindow";
// import ChatList from "../../components/ChatList";

// const WhatsappConfiIndex = () => {
//   const { request } = useRequest();
//   const [form] = Form.useForm();
//   const [qr, setQr] = useState(null);
//   const [authenticated, setAuthenticated] = useState(false);
//   const [chats, setChats] = useState([]);
//   const [selectedChat, setSelectedChat] = useState(null);
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);
//   const [loadingChats, setLoadingChats] = useState(false);

//   useEffect(() => {
//     const fetchQr = () => {
//       request({
//         url: "https://backend.wehadbot.com/api/business/whatsup/get-qr",
//         method: "GET",
//         onSuccess: (data) => {
//           if (data.qr) {
//             setQr(data.qr);
//           } else {
//             setAuthenticated(true);
//             setQr(null);
//             setTimeout(() => {
//               loadChats(page);
//             }, 3000);
//           }
//         },
//         onError: (error) => {
//           ShowToast(error?.response?.data?.message || "QR fetch failed", Severty.ERROR);
//         },
//       });
//     };

//     fetchQr();
//     const interval = setInterval(fetchQr, 8000);
//     return () => clearInterval(interval);
//   }, []);

//   const loadChats = (pageNumber = 1) => {
//     if (loadingChats || !hasMore) return;

//     setLoadingChats(true);

//     request({
//       url: `https://backend.wehadbot.com/api/business/whatsup/chats?page=${pageNumber}&limit=20`,
//       method: "GET",
//       onSuccess: (data) => {
//         if (data?.data?.length > 0) {
//           setChats((prev) => [...prev, ...data.data]);
//           setPage(pageNumber);
//           setHasMore(pageNumber < data.totalPages);
//         } else {
//           setHasMore(false);
//         }
//         setLoadingChats(false);
//       },
//       onError: (error) => {
//         console.error("Failed to load chats", error);
//         setLoadingChats(false);
//         // ShowToast(error?.response?.data?.message || "Failed to load chats", Severty.ERROR);
//       },
//     });
//   };

//   const handleScrollEnd = () => {
//     if (hasMore) {
//       loadChats(page + 1);
//     }
//   };

//   const handleLogout = () => {
//     request({
//       url: "https://backend.wehadbot.com/api/business/whatsup/logout",
//       method: "POST",
//       onSuccess: () => {
//         setAuthenticated(false);
//         setQr(null);  // Reset QR code on logout
//       },
//       onError: (error) => {
//         ShowToast(error?.response?.data?.message || "Logout failed", Severty.ERROR);
//       },
//     });
//   };

//   if (!authenticated) {
//     return (
//       <div className="App" style={{ textAlign: 'center', marginTop: '50px' }}>
//         <h1>WhatsApp Web QR Login</h1>
//         {qr ? (
//           <img src={qr} alt="WhatsApp QR Code" style={{ width: 300, height: 300 }} />
//         ) : (
//           <p>Waiting for QR code or already logged in...</p>
//         )}
//         {/* <button onClick={handleLogout}>Logout</button> */}
//       </div>
//     );
//   }

//   return (
//     <div className="app-container">
//       <div>
//         <button onClick={handleLogout}>Logout</button>
//       </div>
//       <ChatList chats={chats} onSelectChat={setSelectedChat} onScrollEnd={handleScrollEnd} />
//       <ChatWindow chat={selectedChat} />

//     </div>
//   );
// };

// export default WhatsappConfiIndex;

import React, { useState, useEffect, useRef } from "react";
import { Button, Card, Col, Form, Image, Row, Steps, Switch } from "antd";
import { ShowToast, Severty } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
import ChatWindow from "../../components/ChatWindow";
import ChatList from "../../components/ChatList";
import LogoutImage from "../../assets/images/logout-chat-icon.png";
import WhatsappGuide from "../../assets/images/whatsapp-guild-screenshot.png";
import Whatsappguildicon from "../../assets/images/guide-information-button.png";
import WhatsapppScanning from "../../assets/images/whatsapp-sacnning-imagee.svg";
import LogoutIcon from "../../assets/images/logout-newjij0-icon.png";
import { QrcodeOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router";
const { Step } = Steps;
const WhatsappConfiIndex = () => {
  const { request } = useRequest();
  const [form] = Form.useForm();
  const [qr, setQr] = useState(null);
  const [authenticated, setAuthenticated] = useState(false);
  const [chats, setChats] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingChats, setLoadingChats] = useState(false);
  const [device, setDevice] = useState({})
  const [isChatsRequestPending, setIsChatsRequestPending] = useState(false);
  const [isQrRequestPending, setIsQrRequestPending] = useState(false);
  const [lastChatsRequestTime, setLastChatsRequestTime] = useState(null);
  const chatsRequestPendingRef = useRef(false);
  const { id } = useParams();
  const navigate = useNavigate()


  useEffect(() => {
    let interval;

    const fetchQr = async () => {
      // Prevent multiple simultaneous QR requests
      if (isQrRequestPending) {
        console.log("QR request already pending, skipping...");
        return;
      }

      // Set pending state to prevent multiple requests
      setIsQrRequestPending(true);

      request({
        // url: `https://backend.wehadbot.com/api/business/whatsup/get-qr/${id}`,
        // url: `https://backend.wehadbot.com/api/business/whatsup/get-qr/${id}`,
        url: `https://whtb.coffeeandaslice.com/api/business/whatsup/get-qr/${id}`,
        method: "GET",
        onSuccess: (data) => {
          // Reset pending state after successful response
          setIsQrRequestPending(false);

          // If QR code exists, show QR section
          if (data.qr) {
            setQr(data.qr);
            setAuthenticated(false); // Make sure authenticated is false when QR is shown
            return;
          }

          // Check status from backend
          if (data.status === "authenticated") {
            // Only set authenticated when client is actually ready
            setAuthenticated(true);
            setQr(null);
            clearInterval(interval); // 🛑 Stop polling
            setTimeout(() => {
              loadChats(1, false); // ✅ Start loading chats (not polling)
            }, 2000);
          } else {
            // Still waiting or initializing - keep showing QR section
            setAuthenticated(false);
            setQr(null);
          }
        },
        onError: (error) => {
          // Reset pending state after error
          setIsQrRequestPending(false);

          const errorMessage = error?.response?.data?.message;

          if (
            error?.response?.status === 440 &&
            errorMessage?.includes("Unauthorized number scanned")
          ) {
            navigate("/whatsapp-configuration-dashboard")
            ShowToast(errorMessage, Severty.ERROR);
            return;
          }

          ShowToast(errorMessage || "QR fetch failed", Severty.ERROR);
        },

      });
    };
    fetchQr(); // initial fetch
    interval = setInterval(fetchQr, 8000); // polling

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  // Poll chats API every 10 seconds after authentication
  useEffect(() => {
    let chatsInterval;

    if (authenticated) {
      // Reset pending state when authentication changes
      chatsRequestPendingRef.current = false;
      setIsChatsRequestPending(false);

      // Initial load
      loadChats(1, false); // Initial load is not polling

      // Set up polling every 10 seconds
      chatsInterval = setInterval(() => {
        loadChats(1, true); // Polling calls with isPolling = true
      }, 10000); // 10 seconds
    }

    return () => {
      if (chatsInterval) {
        clearInterval(chatsInterval);
      }
      // Reset pending state on cleanup
      chatsRequestPendingRef.current = false;
    };
  }, [authenticated]); // Only run when authenticated state changes

  // Function to load chats with pagination
  const loadChats = (pageNumber = 1, isPolling = false) => {
    // Prevent multiple simultaneous requests to the same API using ref for immediate check
    if (chatsRequestPendingRef.current) {
      console.log(`🚫 Chats request already pending, skipping... (${isPolling ? 'polling' : 'manual'} call) - Ref: ${chatsRequestPendingRef.current}, State: ${isChatsRequestPending}`);
      return;
    }

    // For manual pagination, we want to prevent multiple simultaneous requests
    if (!isPolling && (loadingChats || !hasMore)) {
      console.log("🚫 Manual request blocked - loading or no more data");
      return;
    }

    console.log(`✅ Starting chats request - Page: ${pageNumber}, Polling: ${isPolling}`);

    // Set pending state to prevent multiple requests IMMEDIATELY (both ref and state)
    chatsRequestPendingRef.current = true;
    setIsChatsRequestPending(true);
    setLastChatsRequestTime(new Date().toLocaleTimeString());

    if (!isPolling) {
      setLoadingChats(true);
    }

    request({
      url: `https://whtb.coffeeandaslice.com/api/business/whatsup/chats/${id}?page=${pageNumber}&limit=100`,
      // url: `https://backend.wehadbot.com/api/business/whatsup/chats/${id}?page=${pageNumber}&limit=100`,
      method: "GET",
      onSuccess: (data) => {
        if (data?.data?.length > 0) {
          if (pageNumber === 1) {
            setChats(data.data); // Overwrite chats on the first page
          } else {
            setChats((prev) => [...prev, ...data.data]); // Append new chats on subsequent pages
          }
          // setChats((prev) => [...prev, ...data.data]); // Append new chats
          setPage(pageNumber);
          setHasMore(pageNumber < data.totalPages); // Check if there are more pages
        } else {
          setHasMore(false); // No more chats to load
        }

        console.log(`✅ Chats request completed successfully - Page: ${pageNumber}, Polling: ${isPolling}`);

        // Reset pending state after successful response (both ref and state)
        chatsRequestPendingRef.current = false;
        setIsChatsRequestPending(false);

        if (!isPolling) {
          setLoadingChats(false);
        }
      },
      onError: (error) => {
        console.error(`❌ Chats request failed - Page: ${pageNumber}, Polling: ${isPolling}`, error);

        // Reset pending state after error (both ref and state)
        chatsRequestPendingRef.current = false;
        setIsChatsRequestPending(false);

        if (!isPolling) {
          setLoadingChats(false);
        }
        ShowToast(
          error?.response?.data?.message || "Failed to load chats",
          Severty.ERROR
        );
      },
    });
  };

  // Handle scrolling to load more chats
  const handleScrollEnd = () => {
    if (hasMore) {
      loadChats(page + 1, false); // Load next page of chats (not polling)
    }
  };

  // Logout handler to clear session
  const handleLogout = () => {
    request({
      // url: `https://backend.wehadbot.com/api/business/whatsup/logout/${id}`,
      url: `https://backend.wehadbot.com/api/business/whatsup/logout/${id}`,
      method: "POST",
      onSuccess: () => {
        setAuthenticated(false);
        setQr(null); // Reset QR code on logout
        navigate("/whatsapp-configuration-dashboard")
      },
      onError: (error) => {
        ShowToast(
          error?.response?.data?.message || "Logout failed",
          Severty.ERROR
        );
      },
    });
  };

  // Show QR section if not authenticated (waiting for QR or scanning)
  if (!authenticated) {
    return (
      <div>
        <Row gutter={[16, 16]}>
          {/* Left Panel */}
          <Col xs={24} md={16}>
            <Card
              title="Scan the QR Code On Your Whatsapp Mobile App "
              bordered={false}
              className="main-new-qr-code-div-card"
            >
              <div className="main-new-qr-code-div">
                {qr ? (
                  <img width={250} src={qr} alt="QR Code" />
                ) : (
                  <div style={{ textAlign: 'center', padding: '20px' }}>
                    <div style={{ marginBottom: '10px' }}>Please wait, QR code is loading...</div>
                    <div className="spinner-container" style={{ display: 'inline-block' }}>
                      <svg className="spinner-container" width="65px" height="65px" viewBox="0 0 52 52">
                        <circle className="path" cx="26px" cy="26px" r="20px" fill="none" strokeWidth="4px" />
                      </svg>
                    </div>
                  </div>
                )}
              </div>

              {/* <div className="main-new-permission-chack-box">
                <div>
                  <span style={{ marginRight: 8 }}>
                    حظر جميع الكلمات الواردة
                  </span>
                  <Switch defaultChecked={false} />
                </div>

                <div>
                  <span style={{ marginRight: 8 }}>Enable Voiceflow</span>
                  <Switch defaultChecked={false} />
                </div>
              </div> */}
            </Card>

          </Col>

          {/* Right Panel */}
          <Col xs={24} md={8}>
            <Card
              title="How To Scan?"
              extra={
                <Button className="guild-inforamation-ico">
                  {" "}
                  <img src={Whatsappguildicon} /> Guide
                </Button>
              }
              bordered={false}
            >
              <img
                width="100%"
                height={120}
                src={WhatsappGuide}
                alt="Guide"
                style={{ objectFit: "cover", marginBottom: "30px" }}
              />
              <Steps
                className="how-steps-bar"
                direction="vertical"
                size="small"
                current={-1}
              >
                <Step
                  title={
                    <span className="stpe-designess-text">
                      <h6>Step 1:</h6>
                      <p>Open WhatsApp on your phone</p>
                    </span>
                  }
                  icon={
                    <div className="steps-icon-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M7 2a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zm3 14a1 1 0 100-2 1 1 0 000 2z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                  }
                />
                <Step
                  title={
                    <span className="stpe-designess-text">
                      <h6>Step 2:</h6>
                      <p>Tap Menu or Settings and select Linked Devices</p>
                    </span>
                  }
                  icon={
                    <div className="steps-icon-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path d="M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z" />
                      </svg>
                    </div>
                  }
                />
                <Step
                  title={
                    <span className="stpe-designess-text">
                      <h6>Step 3:</h6>
                      <p>Tap on Link a Device</p>
                    </span>
                  }
                  icon={
                    <div className="steps-icon-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path d="M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z" />
                      </svg>
                    </div>
                  }
                />
                <Step
                  title={
                    <span className="stpe-designess-text">
                      <h6>Step 4:</h6>
                      <p>Point your phone to this screen to capture the code</p>
                    </span>
                  }
                  icon={
                    <div className="steps-icon-button">
                      <QrcodeOutlined />
                    </div>
                  }
                />
              </Steps>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  // Show connection status only when authenticated but chats are loading or empty
  if (authenticated && chats.length === 0) {
    return (
      <div>
        <Row gutter={[16, 16]}>
          {/* Left Panel */}
          <Col xs={24} md={16}>
            <Card
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>Device Connected - Loading Chats</span>
                  <Button
                    className="logout-new-buttonj"
                    icon={
                      <img
                        src={LogoutIcon}
                        alt="Logout"
                        style={{ width: 16 }}
                      />
                    }
                    onClick={handleLogout}
                  >
                    Logout
                  </Button>
                </div>
              }
              bordered={false}
              className="main-new-qr-code-div-card"
            >
              <div className="main-new-qr-code-div">
                <img width={150} src={WhatsapppScanning} alt="Connected" />
                <div id="startup">
                  <svg className="spinner-container" width="65px" height="65px" viewBox="0 0 52 52">
                    <circle className="path" cx="26px" cy="26px" r="20px" fill="none" strokeWidth="4px" />
                  </svg>
                </div>
              </div>
              <div className="connected-divvv">
                <span>
                  Device Connected - Loading chats...
                </span>
              </div>
              {/* <div className="main-new-permission-chack-box">
                <div>
                  <span style={{ marginRight: 8 }}>
                    حظر جميع الكلمات الواردة
                  </span>
                  <Switch defaultChecked={false} />
                </div>

                <div>
                  <span style={{ marginRight: 8 }}>Enable Voiceflow</span>
                  <Switch defaultChecked={false} />
                </div>
              </div> */}
            </Card>
          </Col>

          {/* Right Panel */}
          <Col xs={24} md={8}>
            <Card
              title="How To Scan?"
              extra={
                <Button className="guild-inforamation-ico">
                  {" "}
                  <img src={Whatsappguildicon} /> Guide
                </Button>
              }
              bordered={false}
            >
              <img
                width="100%"
                height={120}
                src={WhatsappGuide}
                alt="Guide"
                style={{ objectFit: "cover", marginBottom: "30px" }}
              />
              <Steps
                className="how-steps-bar"
                direction="vertical"
                size="small"
                current={-1}
              >
                <Step
                  title={
                    <span className="stpe-designess-text">
                      <h6>Step 1:</h6>
                      <p>Open WhatsApp on your phone</p>
                    </span>
                  }
                  icon={
                    <div className="steps-icon-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M7 2a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zm3 14a1 1 0 100-2 1 1 0 000 2z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                  }
                />
                <Step
                  title={
                    <span className="stpe-designess-text">
                      <h6>Step 2:</h6>
                      <p>Tap Menu or Settings and select Linked Devices</p>
                    </span>
                  }
                  icon={
                    <div className="steps-icon-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path d="M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z" />
                      </svg>
                    </div>
                  }
                />
                <Step
                  title={
                    <span className="stpe-designess-text">
                      <h6>Step 3:</h6>
                      <p>Tap on Link a Device</p>
                    </span>
                  }
                  icon={
                    <div className="steps-icon-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path d="M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z" />
                      </svg>
                    </div>
                  }
                />
                <Step
                  title={
                    <span className="stpe-designess-text">
                      <h6>Step 4:</h6>
                      <p>Point your phone to this screen to capture the code</p>
                    </span>
                  }
                  icon={
                    <div className="steps-icon-button">
                      <QrcodeOutlined />
                    </div>
                  }
                />
              </Steps>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
  return (
    <div className="app-container">
      {/* <div>
        <Button className="main-new-logout-button" onClick={handleLogout}>
          {" "}
          <img src={LogoutImage} />{" "}
        </Button>
      </div> */}

      {/* API Status Indicator */}
      {/* {isChatsRequestPending && (
        <div style={{
          position: 'fixed',
          top: '10px',
          right: '10px',
          backgroundColor: '#1890ff',
          color: 'white',
          padding: '8px 12px',
          borderRadius: '4px',
          fontSize: '12px',
          zIndex: 1000,
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
        }}>
          🔄 Loading chats... {lastChatsRequestTime && `(Started: ${lastChatsRequestTime})`}
        </div>
      )} */}

      <ChatList
        chats={chats}
        onSelectChat={setSelectedChat}
        onScrollEnd={handleScrollEnd}
      />
      <ChatWindow chat={selectedChat} scanId={id} />
    </div>
  );
};

export default WhatsappConfiIndex;
